module.exports = __webpack_public_path__ + "img/emp_img.114c4663.png";